<div class="ui container text-center">
    <admin-occasions-filter [occasionsFilters]="occasionsFilters"
                            [occasionsSorting]="occasionsSorting"
                            (refreshed)="triggerRefresh()">
    </admin-occasions-filter>
    <div>
        <admin-occasion *ngFor="let occasion of occasionsSorting.Value()" [occasion]="occasion"></admin-occasion>
    </div>
    <waiting-popup [waitingMessage]="waitingMessage"
                   [successMessage]="successMessage"
                   [errorMessage]="errorMessage">
    </waiting-popup>
</div>


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/admin/occasions/presentation/presentation.html